import { createAccountBuilder } from './operations/createAccount.mjs';
import { transferSolBuilder } from './operations/transferSol.mjs';

/**
 * This client allows you to access the underlying Transaction Builders
 * for the write operations of the System module.
 *
 * @see {@link SystemClient}
 * @group Module Builders
 * */
class SystemBuildersClient {
  constructor(metaplex) {
    this.metaplex = metaplex;
  }

  /** {@inheritDoc createAccountBuilder} */
  createAccount(input, options) {
    return createAccountBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc transferSolBuilder} */
  transferSol(input, options) {
    return transferSolBuilder(this.metaplex, input, options);
  }
}

export { SystemBuildersClient };
//# sourceMappingURL=SystemBuildersClient.mjs.map
